import styled ,{css} from 'styled-components'
import { Button } from 'antd'

export const Primary = styled(Button)`
  padding: 0.5rem 2rem;
  height: auto !important;
  font-size: 1rem;
  text-transform : uppercase;
  font-weight: bold;
  width: fit-content;
  margin-top: 1rem;
  border_radius: 5px;

  ${({confirmation})=> !!confirmation && css`
    min-width: 16rem;
  `}

  color: ${props => props.theme.WHITE};
  background-color: ${props => props.theme.PRIMARY_TEXT_COLOR} !important;
  border: 1px ${props => props.theme.OFI_PURPLE} !important;

  &:hover {
    color: ${props => props.theme.WHITE};
    box-shadow: 0 0 0 1px ${props => props.theme.OFI_PURPLE} !important;
  }

  &:focus {
    color: ${props => props.theme.WHITE};
    box-shadow: 0 0 0 1px ${props => props.theme.OFI_PURPLE} !important;
  }
`
export const Default = styled(Button)`
  padding: 0.5rem 2rem;
  height: auto !important;
  font-size: 1rem;
  text-transform: uppercase;
  font-weight: bold;
  width: fit-content;
  margin-top: 1rem;
  border_radius: 5px;

  color: ${props => props.theme.WHITE};
  background-color: ${props => props.theme.PRIMARY_TEXT_COLOR} !important;
  border: 1px ${props => props.theme.OFI_PURPLE} !important;

  &:hover {
    box-shadow: 0 0 0 1px ${props => props.theme.OFI_PURPLE} !important;
    color: ${props => props.theme.WHITE};
  }

  &:focus {
    color: ${props => props.theme.WHITE};
    box-shadow: 0 0 0 1px ${props => props.theme.OFI_PURPLE} !important;
  }

  ${({ confirmation }) =>
    !!confirmation &&
    css`
      min-width: 16rem;
    `}
  ${({qrConfirmation})=> !!qrConfirmation && css`
    font-size: 0.7rem;
  `}
`